import { Util } from '../util';
export namespace WorkBench {
    /** 组件类型枚举 */
    export enum WorkBenchComponentType {
        /** 待办组件 */
        MyWork = 100,

        /** 消息提醒组件 */
        MyMessage = 101,

        /** 快速新增组件 */
        QuickAdd = 102,

        /** 快捷入口组件 */
        QuickEntry = 103,

        /** 常用应用组件 */
        FrequentlyApp = 104,

        /** 仪表盘/报表类组件，这个是指组件在没有选择绑定的图表时的编码 */
        Chart = 105,

        /** 全部应用组件 */
        AppGroups = 106,
    }

    /** 系统组件id枚举 */
    export enum SystemComponentId {
        /** 待办组件 */
        MyWork = 'MyWork',

        /** 消息提醒组件 */
        MyMessage = 'MyMessage',

        /** 快速新增组件 */
        QuickAdd = 'QuickAdd',

        /** 快捷入口组件 */
        QuickEntry = 'QuickEntry',

        /** 常用应用组件 */
        FrequentlyApp = 'FrequentlyApp',

        /** 全部应用组件 */
        AppGroups = 'AppGroups',
    }

    /** 所有工作台组件类型列表 */
    export const BUILT_IN_COMPONENTS = [
        WorkBenchComponentType.Chart,
        WorkBenchComponentType.FrequentlyApp,
        WorkBenchComponentType.MyMessage,
        WorkBenchComponentType.MyWork,
        WorkBenchComponentType.QuickAdd,
        WorkBenchComponentType.QuickEntry,
        WorkBenchComponentType.AppGroups,
    ];

    /** 工作台组件基本数据结构 */
    export interface IWorkbenchComponent {
        /** 组件唯一标识 */
        id: string;

        /** 组件类型 */
        type: WorkBenchComponentType;

        /** 组件名称 */
        name: string;

        /** 组件布局 */
        layout: {
            /** 组件横坐标 */
            x: number;

            /** 组件纵坐标 */
            y: number;

            /** 组件宽度 */
            w: number;

            /** 组件高度 */
            h: number;
        };

        /** 组件额外配置 */
        extSetting: unknown;
    }

    /** 工作台快捷入口组件额外配置数据类型 */
    export interface IQuickEntrySetting {
        /** 快捷入口表单编码 */
        functionNodeCodes: string[];
    }

    /** 工作台常用应用组件额外配置数据类型 */
    export interface IFrequentlyAppSetting {
        /** 常用应用应用编码 */
        functionNodeCodes: string[];
    }

    /** 工作台报表图表组件额外配置数据类型 */
    export interface IReportChartSetting {
        /** 图表编码 */
        chartCode: string;

        /** 报表编码 */
        schemaCode: string;

        /** 应用编码 */
        appCode: string;

        /** 是否旧报表 */
        isReport: boolean;
    }

    /** 组件展示模式 */
    export enum ComponentMode {
        /** 卡片模式 */
        Card = 0,

        /** 列表模式 */
        List = 1,
    }

    /** 工作台数据结构 */
    export interface IWorkbench {
        /** 工作台类型 */
        device: Util.Device;

        /** 工作台组件信息数组 */
        components: IWorkbenchComponent[];

        /** 工作台版本 */
        version: number;

        /** 是否是默认工作台 */
        isDefault?: boolean;

        /** 工作台组件展示模式(key是组件id，不写到组件extSetting里是因为在删除组件后保留配置) */
        componentModes: Record<string, ComponentMode> | null;
    }
}
